module.exports = __webpack_public_path__ + "img/dnk.eb1416e0.svg";